import React from "react";
import { TabsList, TabsTrigger, TabsContent } from "./ui/tabs";

export function RecordSectionNav({items,label}) {
  return <TabsList aria-label={label} className="h-auto w-full flex-wrap justify-start gap-1 bg-card p-2">
    {items.map(([value,title])=><TabsTrigger key={value} value={value} className="min-h-11 whitespace-normal text-left">{title}</TabsTrigger>)}
  </TabsList>;
}

// Keep the panels mounted so drafts, signatures and payment inputs survive tab changes.
export function RecordPanel({value,children}) {
  return <TabsContent value={value} forceMount className="mt-5 space-y-5 data-[state=inactive]:hidden">{children}</TabsContent>;
}
